import { EventBus } from 'primevue/utils';

var OverlayEventBus = EventBus();

export { OverlayEventBus as default };
//# sourceMappingURL=overlayeventbus.mjs.map
